import { Injectable, inject } from '@angular/core'
import { Store, Action } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

@Injectable({
  providedIn: 'root',
})
export class StripeFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  dispatch(action: Action) {
    this.store.dispatch(action)
  }
}
